import { render, staticRenderFns } from "./ContentParser.vue?vue&type=template&id=60874ae9"
import script from "./ContentParser.vue?vue&type=script&lang=js"
export * from "./ContentParser.vue?vue&type=script&lang=js"
import style0 from "./ContentParser.vue?vue&type=style&index=0&id=60874ae9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports